import { useEffect, useState } from 'react';
import { NavLink, useParams } from "react-router-dom";
import { getData } from '../../utils/apiCalls';
import { ImgSlider } from './ImgSlider';
import { svgs } from '../../assets/svgs';
import { Loader } from '../Loader';
import agenda from '../../data/agenda.json'


export const Schedule = () => {
   const [schedule, setSchedule] = useState([]);
   const [isSummitTimeZone, setIsSummitTimeZone] = useState(true);
   const [isLoading, setIsLoading] = useState(true);
   const { day } = useParams()
   const timezoneDict = {
      "ET": "Eastern",
      "PT": "Pacific",
   };

   useEffect(() => {
      setSchedule(agenda)
      // getData(`https://youngstartup.io/api/cwebsite/get_agenda?event=NYVS24`)
      //    .then(res => {
      //       setSchedule(res)
      //       setIsLoading(false)
      //    })
   }, [])

   const handleCheckboxChange = (event) => {
      setIsSummitTimeZone(event.target.checked);
   }

   const getDays = () => {
      return schedule.days_content.filter(d => d.day === Number(day))
   }

   const place = Intl.DateTimeFormat().resolvedOptions().timeZone.split('/')[1]
   const myPlace = place ? place.replaceAll('_', ' ') : 'local'

   return (
      <div key={Math.random()} className='schedule'>
         {/* {isLoading && <Loader color='dark2' />} */}
          <div className='container'>
            <header className='header'>
               <nav className='days-nav'>
                  <NavLink id='glowLink' to={'/agenda/0'}>
                     All days
                     {svgs.glow}
                  </NavLink>
                  {
                     schedule.days_content?.map(day_content =>
                        <NavLink to={`/agenda/${day_content.day}`} id='glowLink' key={day_content.name}>
                           {day_content.name}
                           {svgs.glow}
                        </NavLink>
                     )
                  }
               </nav>
               <section className='zone'>
                  <div className='title-zone'>
                     <h6>Time Zone</h6>
                     <span>|</span>
                  </div>

                  <div className='summit-zone'>
                     <h6>Summit</h6>
                     <span>{timezoneDict[schedule.timezone]}</span>
                  </div>

                  <div id='timeZoneCheckBox'>
                     <label>
                        <input
                           type="checkbox"
                           checked={isSummitTimeZone}
                           onChange={handleCheckboxChange}
                        />
                        <span></span>
                     </label>
                  </div>

                  <div className='local-zone'>
                     <h6>Local</h6>
                     <span>{myPlace}</span>
                  </div>
               </section>
            </header>
            {
               Number(day) === 0 &&
               schedule?.days_content?.map(day_content =>
                  <main key={Math.random()} className='main'>
                     <div className='day'>
                        <h6>Day {day_content?.day} - {day_content?.name}</h6>
                     </div>
                     <DaySchedual
                        schedule={schedule}
                        isSummitTimeZone={isSummitTimeZone}
                        day_content={day_content}
                     />
                  </main>)
            }
            {
               Number(day) !== 0 &&
               getDays().map(day_content =>
                  <main key={Math.random()} className='main'>
                     <div className='day'>
                        <h6>Day {day_content?.day} - {day_content?.name}</h6>
                     </div>
                     <DaySchedual
                        schedule={schedule}
                        isSummitTimeZone={isSummitTimeZone}
                        day_content={day_content}
                     />
                  </main>
               )
            }
         </div >
      </div >
   )
}

const DaySchedual = ({ schedule, isSummitTimeZone, day_content }) => {
   return (
      <>
         {
            day_content?.hours.map((hour, hourIdx) =>
               <article key={hourIdx + day_content?.day} className='hour-artical'>
                  <div className='hour'>
                     <h6>{isSummitTimeZone ? hour?.hour : new Date(`${hour?.datetime} ${schedule?.timezone_diff}`).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</h6>
                  </div>
                  <div className='hour-artical-main'>
                     <span></span>
                     {
                        hour?.sessions.map((session, idx) => {
                           return <div key={idx} className='session'>
                              <header className='session-header'>
                                 <div className='session-header-date'>
                                    {
                                       session?.location &&
                                       <section>
                                          {svgs.room}
                                          <h6>{session?.location}</h6>
                                       </section>
                                    }
                                    <section >
                                       {svgs.callender}
                                       <h6>{new Date(session?.datetime_start).toLocaleDateString("en-US", { month: 'long', day: 'numeric' })}</h6>
                                    </section>
                                    <section >
                                       {svgs.clock}
                                       <h6>{session?.item_duration} Minutes</h6>
                                    </section>
                                 </div>
                                 <h5>{session?.name}</h5>
                                 <h6>{session?.description}</h6>
                              </header>
                              <section className='session-content'>
                                 {
                                    session?.speakers?.length > 0 && <ImgSlider speakers={session?.speakers} />
                                 }
                              </section>
                           </div>
                        }
                        )
                     }
                  </div>
               </article>)
         }
      </>
   )
}